import {
	column,
	Config,
	createComponent,
	datasourcestore,
	DataSourceStore,
	datecolumn,
	ListEventMap,
	Table
} from "@intermesh/goui";
import {jmapds} from "@intermesh/groupoffice-core";

import {t} from "./Translate";
export class FormTable extends Table<DataSourceStore> {
	constructor() {

		const store = datasourcestore({
			dataSource: jmapds("Form"),
			queryParams: {
				limit: 20,
				filter: {
				}
			},
			sort: [{property: "title", isAscending: true}]
		});

		const columns = [
			column({
				header: t("Title"),
				id:"title",
				resizable: true,
				sortable: true,
				width: 180
			}),
			datecolumn({
				header: t("Open"),
				id: "dateOpen",
				sortable: true
			}),
			datecolumn({
				header: t("Closed"),
				id: "dateClosed",
				sortable: true
			})
		];
		
		super(store, columns );

		this.rowSelectionConfig =  {
			multiSelect: true
		};

		this.headers = true;

	}
}

export const formtable = (config?: Config<FormTable>) => createComponent(new FormTable(), config);